import COLOR from 'styles/color';

export const theme = {
  color: {
    primary: COLOR.NAVY_BLUE_001,
    onPrimary: COLOR.WHITE_001,

    secondary: COLOR.WHITE_002,
    onSecondary: COLOR.BLACK_001,

    tertiary: COLOR.GRAY_001,

    background: COLOR.WHITE_001,
    onBackground: COLOR.BLACK_001,

    subText: COLOR.GRAY_001,

    codeBackground: COLOR.GRAY_002,
    tableCellBackground: COLOR.GRAY_002,
    tableBorder: COLOR.GRAY_003,
    toggleListSummaryBackground: COLOR.GRAY_003,
    mdxImageWrapperBorder: COLOR.GRAY_003,

    projectColorSmody: COLOR.PURPLE_001,
    projectColorAtsay: COLOR.BLACK_002,
    projectColorDonggukAlrimi: COLOR.ORANGE_001,
  },
};
